"use client";

import type { ComponentConfig } from "@puckeditor/core";
import { BlogImage } from "../../../../mdx-components";
import { studioImageField } from "@/puck/fields/studioImageField";
import { studioAltField } from "@/puck/fields/studioAltField";
import type { StudioImageBlockProps } from "@/puck/types/blockProps";
import {
  DEFAULT_STUDIO_IMAGE_HEIGHT,
  DEFAULT_STUDIO_IMAGE_WIDTH,
  getStudioImageClassName,
  getStudioImageWrapperStyle,
  resolveStudioImageDimensions,
  type StudioImageSpacingRem,
} from "@/utils/studioImageStyles";

export const STUDIO_IMAGE_SPACING_FIELD_OPTIONS: Array<{
  label: string;
  value: StudioImageSpacingRem;
}> = [
  { label: "0", value: 0 },
  { label: "0.5", value: 0.5 },
  { label: "1", value: 1 },
  { label: "1.5", value: 1.5 },
  { label: "2", value: 2 },
];

export const studioImageSpacingField = (label: string) => ({
  type: "select" as const,
  label,
  options: STUDIO_IMAGE_SPACING_FIELD_OPTIONS,
});

export const studioImageDefaultProps: StudioImageBlockProps = {
  src: "/images/compliance/hero-sm.webp",
  alt: "Descriptive alt text",
  width: DEFAULT_STUDIO_IMAGE_WIDTH,
  height: DEFAULT_STUDIO_IMAGE_HEIGHT,
  marginRem: 0,
  paddingRem: 0,
};

export function renderStudioImageBlock({
  src,
  alt,
  width,
  height,
  marginRem = 0,
  paddingRem = 0,
}: StudioImageBlockProps) {
  const dimensions = resolveStudioImageDimensions(width, height);
  return (
    <BlogImage
      src={src}
      alt={alt}
      width={dimensions.width}
      height={dimensions.height}
      className={getStudioImageClassName()}
      style={getStudioImageWrapperStyle({
        width: dimensions.width,
        height: dimensions.height,
        marginRem,
        paddingRem,
      })}
    />
  );
}

export function createStudioImageBlockConfig(
  label: string,
): ComponentConfig<StudioImageBlockProps> {
  return {
    label,
    fields: {
      src: studioImageField("Image URL / upload"),
      alt: studioAltField(),
      width: { type: "number", label: "Width (px)" },
      height: { type: "number", label: "Height (px)" },
      marginRem: studioImageSpacingField("Margin (rem)"),
      paddingRem: studioImageSpacingField("Padding (rem)"),
    },
    defaultProps: studioImageDefaultProps,
    render: renderStudioImageBlock,
  };
}
